import React from 'react';

import { ISelectOption } from 'components/shared/BaseFormComponents/Select/types';

import { useAreaPageQuery } from './useAreaPageQuery';
import { usePropertyPageQuery } from './usePropertyPageQuery';

type Props = {
  pageId?: string | number | null;
};

export const usePropertyData = ({ pageId }: Props) => {
  const { isValidPropertyPage, data, isFetching } = usePropertyPageQuery({ pageId: pageId });
  const areaPageId = data?.areaPageId;

  const areaPageQueryRes = useAreaPageQuery({ pageId: areaPageId });

  const isLoading = areaPageQueryRes.isFetching || isFetching;

  const activeAreaPage: ISelectOption | null = React.useMemo(() => {
    const areaPageQueryData = areaPageQueryRes.data;
    if (!areaPageQueryData) return null;

    return { id: areaPageQueryData.id as string, name: areaPageQueryData.name };
  }, [areaPageQueryRes.data]);

  return { activeAreaPage, isValidPropertyPage, propertyPageData: data, isLoading };
};
